import React from 'react'
import {Link, withRouter} from "react-router-dom"
import '../../../assets/style/getStarted.scss'
import {Breadcrumbs, Typography} from "@material-ui/core";
import HomeIcon from '@material-ui/icons/Home';
import {withStyles} from "@material-ui/core/styles";
import AsciiDoc from "../../components/AsciiDoc/AsciiDoc";

const styles = theme => ({
    tab: {
        color: '#702F8A',
        '&:hover': {
            color: 'black'
        },
        '&:focus': {
            boxShadow: 'none',
            outline: 'none'
        },
        fontWeight: 300,
        minWidth: '90px',
        width: '90px'
    },
    indicator: {
        backgroundColor: '#702F8A'
    },
    link: {
        display: 'flex',
        color: '#008577',
        '&:hover': {
            color: 'grey'
        },
    },
    icon: {
        marginRight: theme.spacing(0.5),
        width: 20,
        height: 20,
    }
});

const GetStartedV2 = (props) => {

    const {classes} = props;
    return (
        <div className="root-all bg-white">
            <div className={"breadcrumbs-container"}>
                <Breadcrumbs style={{marginTop: "55px", marginLeft: "40px"}} aria-label="breadcrumb">
                    <Link to={"/"} color="inherit"
                          className={classes.link}>
                        <HomeIcon className={classes.icon}/>
                        <Typography style={{fontSize: "15px"}}>Home</Typography>
                    </Link>
                    <Typography style={{fontSize: "15px"}} color="textPrimary">Get started as TPP</Typography>
                </Breadcrumbs>

                <span style={{
                    fontFamily: "Montserrat",
                    fontWeight: "600",
                    fontSize: "24px",
                    marginLeft: "40px",
                    color: "#D6246E"
                }}>
                      Get started as a third party provider
                  </span>
            </div>
            <div style={{paddingTop: "20px"}} className="root-all bg-white">
                <AsciiDoc staticResource={`/documentation/start_as_tpp.adoc`} minusDocHeight={"250px"} />
            </div>
        </div>
    );
}

export default (withStyles(styles)(withRouter(GetStartedV2)))
